export const dateMask = "##/##/####";
export const timeMask = "##:##";
export const timeWithSecMask = "##:##:##";
export const phoneMask = ["(##) ####-####", "(##) #####-####"];
export const cnpjMask = "##.###.###/####-##";
export const cpfMask = "###.###.###-##";
export const rgMask = "##.###.###-#";
export const ieMask = "###.###.###.###";
export const cepMask = "#####-###";